import { ContextLanguage } from "../../context/Context.Language";
import React from "react";
import { useNavigate } from "react-router-dom";
import OrderSuccess from "../order/render/Order.Success";

const OrderReceived = () => {
  React.useEffect(() => {
    sessionStorage.removeItem("busket_program");
    sessionStorage.removeItem("cart");
    sessionStorage.removeItem("redirect");
    sessionStorage.removeItem("date_time");
    sessionStorage.removeItem("address");
    sessionStorage.removeItem("addressDetail");
  }, []);
  return (
    // <div className=" mt-16 md:mt-[72px] ">
    //   <div className="font-bold text-28px">
    //     {language === "TH" ? "ได้รับออเดอร์แล้ว" : "Order Received"}
    //   </div>
    //   <div>
    //     {language === "TH" ? (
    //       "เราได้รับออเดอร์ของคุณแล้ว และจะดำเนินการทันที ให้คุณแน่ใจว่าเราจะไปรับและส่งคืนตรงเวลา! หากมีคำถามอื่นๆเกี่ยวกับออเดอร์ของคุณ กรุณาติดต่อเรา"
    //     ) : (
    //       <div className="text-center">
    //         We received your order and will process it now. You can rely on us:
    //         we will pick-up and return your order on time!
    //         <div className="text-center">
    //           If you have any questions about your order you can
    //           <span className="linkblue"> Contact Us</span>.
    //         </div>
    //       </div>
    //     )}
    //   </div>
    //   <div className="flex">
    //     <div
    //       className="border border-blue-500 cursor-pointer"
    //       onClick={() => {
    //         navigate("/Order");
    //       }}
    //     >
    //       My Order
    //     </div>
    //     <div
    //       className="border border-blue-500 cursor-pointer"
    //       onClick={() => {
    //         navigate("/");
    //       }}
    //     >
    //       Home
    //     </div>
    //   </div>
    // </div>
    <OrderSuccess />
  );
};

export default OrderReceived;
